<template>
  <v-container id="customer-report" fluid tag="section">

    <FilterForm 
      :filter-form="filterForm"
      @click-search="search"
    />

    <RevenueReport
      :filter-form="filterForm"
    />

    <SourceReport
      :filter-form="filterForm"
    />

    <PaymentReport
      :filter-form="filterForm"
    />

    <CityReport
      :filter-form="filterForm"
    />

  </v-container>
</template>

<script>

import FilterForm from './components/FilterForm'
import RevenueReport from './components/RevenueReport'
import SourceReport from './components/SourceReport'
import PaymentReport from './components/PaymentReport'
import CityReport from './components/CityReport'

import { colorChart } from '@/helpers/constants'
import * as moment from 'moment'

export default {
   components: { 
    FilterForm,
    RevenueReport,
    SourceReport,
    PaymentReport,
    CityReport,
  },
  data() {
    return {
      filterForm: {
        dateRange: {
          startDate: moment().startOf('isoWeek').format('YYYY-MM-DD'),
          endDate: moment().endOf('isoWeek').format('YYYY-MM-DD'),
        },
      },
    };
  },
  created() {
    this.search()
  },
  methods: {
    search (filterForm) {
      if(filterForm) {
        this.filterForm = filterForm
      }
      Bus.$emit('revenue-report-thpt', this.filterForm)
      Bus.$emit('source-report-thpt', this.filterForm)
      Bus.$emit('payment-report-thpt', this.filterForm)
      Bus.$emit('city-report-thpt', this.filterForm)
    },
  }
}
</script>

<style lang="scss">
  .ct-major-second {
    svg {
      position: relative;
    }
    &:before {
      padding-bottom: 0;
    }
  }

  #customer-report {
    ul.description {
      display: flex;
      justify-content: center;
      margin: 10px 0;
      li {
        margin: 0 5px;
      }
    }
  }

  #customer-report {
    .ct-series-a .ct-slice-pie {
      fill: teal;
    }

    .ct-series-b .ct-slice-pie {
      fill: royalblue;
    }
    
    .ct-series-c .ct-slice-pie {
      fill: darkgrey;
    }

    .ct-series-d .ct-slice-pie {
      fill: red;
    }

    .ct-series-e .ct-slice-pie {
      fill: yellow;
    }

    .ct-series-f .ct-slice-pie {
      fill: hotpink;
    }

    .ct-series-g .ct-slice-pie {
      fill: aqua;
    }

    .ct-series-h .ct-slice-pie {
      fill: gold;
    }
    
    .ct-series-i .ct-slice-pie {
      fill: blueviolet;
    }
    
    .ct-series-j .ct-slice-pie {
      fill: maroon;
    }

    .ct-label {
      fill: white;
    }
  }
</style>